module.exports = __webpack_public_path__ + "static/media/icomoon.3f533c05.ttf";